import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { T } from "@/constants/testIds";

export default function WhoIsJesus() {
  return (
    <section data-testid={T.whoIsJesus} className="py-24 sm:py-32">
      <div className="container-editorial grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <img
            src="https://images.pexels.com/photos/7076710/pexels-photo-7076710.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1000"
            alt="An open Bible with soft golden light"
            className="w-full h-[420px] sm:h-[540px] object-cover"
            width="1000"
            height="800"
            loading="lazy"
          />
        </div>
        <div className="lg:col-span-6 order-1 lg:order-2">
          <span className="eyebrow">The person at the centre</span>
          <h2 className="heading-1 mt-4">
            Who is <em className="italic text-forest">Jesus Christ</em>?
          </h2>
          <p className="lead mt-6">
            Every religion has an opinion about Jesus. Christianity worships Him.
          </p>
          <p className="body-copy mt-4 text-ink-muted">
            The Bible calls Him the eternal Word who became flesh; the sinless Son who died for our sins; the risen
            Lord who defeated death; the one Mediator between God and humanity. Read Him for yourself, and see whom
            He claims to be.
          </p>
          <div className="mt-8 flex items-center gap-3">
            <Link to="/know-jesus" className="btn-primary">
              Explore Who Jesus Is <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/articles/who-is-jesus-christ" className="btn-ghost">
              Read the article
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
